import React from "react";
import { useTranslation } from "react-i18next";

export default function CategoryList({ categories, selectedCategory, onSelectCategory }) {
  const { t } = useTranslation();
  return (
    <div>
      <h2 className="text-xl font-bold mb-4">{t("categories")}</h2>
      <ul className="space-y-2">
        {categories.map((category) => (
          <li
            key={category}
            className={`cursor-pointer px-3 py-2 rounded ${
              selectedCategory === category ? "bg-background text-text" : "hover:bg-[#E5D3DD]"
            }`}
            onClick={() => onSelectCategory(category)}
          >
            {category}
          </li>
        ))}
      </ul>
    </div>
  );
}